<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {Table} from 'sveltestrap'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {doShow as showAlert} from '../../#common/alert/store'
    import IconifyIcon from '@iconify/svelte'
    import viewIcon from '@iconify/icons-fa-solid/eye'
    import telegramIcon from '@iconify/icons-fa-brands/telegram'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import {getUsersTasks, moderateUserTask, sendUserMessage, getStats} from 'src/components/cabinet/#services/tasksBot'

    enum Status {
        pending,
        approved,
    }

    let moderateModalOpen = false
    let messageModalOpen = false
    let selectedTask
    let selectedClientId
    let currentPage = 0
    let perPage = 25
    let maxButtons = 5
    let status = Status.pending
    let newReward
    let reason
    let message

    getStats.send()

    $: status,currentPage,perPage,filter()

    function filter() {
        getUsersTasks.reset()
        getUsersTasks.send({data:{ page: currentPage + 1, perPage, status }})
        $getUsersTasks.value
    }

    async function moderateTask(status) {
        try {
            await moderateUserTask.request({data: {
                id: selectedTask.id,
                status,
                comment: reason ? reason : undefined,
                customAward: newReward && newReward !== selectedTask?.taskAward ? newReward : undefined
            }})

            reason = ''
            newReward = undefined
            moderateModalOpen = false
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            filter()
        }
    }

    async function sendMessage() {
        if (message !== '') {
            try {
                await sendUserMessage.request({data: {clientId: selectedClientId, message}})

                messageModalOpen = false

                showAlert.set({
                    status: 'success',
                    text: 'Message successfully sent!'
                })
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            }
        }
    }
</script>

<svelte:head>
    <title>Quests Bot</title>
</svelte:head>

<MainLayout title="Quests Bot">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="tasks/categories" class="btn btn-primary mb-3">Categories</Link>
                <Link to="tasks/all" class="btn btn-primary mb-3">Tasks</Link>
                <Link to="tasks/leaderboard" class="btn btn-primary mb-3">Leaderboard</Link>
                <Link to="tasks/search" class="btn btn-primary mb-3">Search</Link>
                <div class="analytics">
                    {#if !$getStats.hasValue && $getStats.loading}
                        <div>Loading...</div>
                    {:else if !$getStats.hasValue && $getStats.error }
                        <div>Something went wrong</div>
                    {:else if $getStats.value}
                        <div><strong>Users</strong>: {$getStats.value?.usersCount}</div>
                        <div><strong>Completed tasks</strong>: {$getStats.value?.tasksCount}</div>
                    {/if}
                </div>
                <div class="dropdown-wrapper mb-3">
                    <span>Status:</span>
                    <select class="form-select" bind:value={status}>
                        <option value={undefined}>All</option>
                        {#each {length: Object.keys(Status).length / 2} as _, key}
                            <option value={key}>{Status[key]}</option>
                        {/each}
                    </select>
                </div>
                {#if $getUsersTasks.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$getUsersTasks.loading || $getUsersTasks.loading}
                        totalCount={$getUsersTasks.value.totalCount}
                    />
                {/if}
                <div class="tasks-list">
                    <Table bordered responsive>
                        <thead>
                        <tr>
                            <td class="text-center">ID</td>
                            <td class="text-center">Status</td>
                            <td>Title</td>
                            <td class="text-center">User</td>
                            <td class="text-center">Stats</td>
                            <td class="text-center">Actions</td>
                        </tr>
                        </thead>
                        <tbody>
                        {#if !$getUsersTasks.hasValue && $getUsersTasks.loading}
                            <tr>
                                <td class="text-center" colSpan="6">Loading...</td>
                            </tr>
                        {:else if !$getUsersTasks.hasValue && $getUsersTasks.error }
                            <tr>
                                <td class="text-center" colspan="6">Something went wrong. Try refreshing the page.</td>
                            </tr>
                        {:else if $getUsersTasks.value}
                            {#each $getUsersTasks.value.data as {
                                id,
                                taskTitle,
                                taskDescription,
                                taskLink,
                                clientId,
                                stats,
                                doneTask,
                                taskAward,
                                status,
                                customAward,
                                comment,
                                userName,
                                blackList,
                                suspicious
                            }}
                                <tr class:suspicious={suspicious} class:blackList={blackList}>
                                    <td>#{id}</td>
                                    <td><span class="status-{Status[status]}">{Status[status]}</span></td>
                                    <td>{taskTitle}</td>
                                    <td>
                                        <a href="/tasks/profile/{clientId}" target="_blank">{clientId}</a>
                                        {#if userName}
                                            <a href="https://t.me/{userName}" class="tg-icon" target="_blank">
                                                <IconifyIcon icon={telegramIcon}/>
                                            </a>
                                        {/if}
                                    </td>
                                    <td title="Completed / Approved / Rejected">
                                        <span class="orange">{stats.done}</span> /
                                        <span class="green">{stats.approved}</span> /
                                        <span class="red">{stats.rejected}</span>
                                    </td>
                                    <td>
                                        <button class="btn btn-primary" title="Moderate" on:click={() => {
                                            selectedTask = {
                                                id,
                                                taskTitle,
                                                taskDescription,
                                                taskLink,
                                                doneTask: JSON.parse(doneTask),
                                                taskAward,
                                            }
                                            reason = comment ? comment : ''
                                            newReward = customAward ? customAward : taskAward
                                            moderateModalOpen = true
                                        }}>
                                            <IconifyIcon icon={viewIcon}/>
                                        </button>
                                    </td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                    {#if $getUsersTasks.hasValue}
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$getUsersTasks.value.totalCount}
                            {perPage}
                            {maxButtons}
                            disabled={$getUsersTasks.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
        <Modal bind:visible={moderateModalOpen} size="xl">
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Moderation {selectedTask.taskTitle}</div>
                <div class="modal-custom__text">
                    <div class="mb-3">
                        <strong>Description</strong>: {@html selectedTask.taskDescription}
                    </div>
                    {#if selectedTask?.taskLink}
                        <div class="mb-3">
                            <strong>Link</strong>:
                            <a href="{selectedTask.taskLink}" target="_blank">{selectedTask.taskLink}</a>
                        </div>
                    {/if}
                    {#if selectedTask?.doneTask}
                        {#if selectedTask.doneTask?.userDescription}
                            <div class="mb-3">{selectedTask.doneTask.userDescription}</div>
                        {/if}
                        {#if selectedTask.doneTask?.userAttachments}
                            <div class="mb-3">
                                {#each selectedTask.doneTask.userAttachments as image}
                                    <a href={image} target="_blank">
                                        <img src={image} class="img-fluid user-image" alt="">
                                    </a>
                                {/each}
                            </div>
                        {/if}
                    {/if}
                    <div class="input-group mb-3">
                        <span class="input-group-text">Reward</span>
                        <input type="number" class="form-control" bind:value={newReward}/>
                    </div>
                    <textarea class="form-control" placeholder="Reason..." bind:value={reason}></textarea>
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { moderateModalOpen = false }}>Close</button>
                    <button class="btn btn-danger" on:click={() => moderateTask(2)}>Deny</button>
                    <button class="btn btn-success" on:click={() => moderateTask(1)}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={messageModalOpen}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Send private message</div>
                <div class="modal-custom__text">
                    <label>Message:</label>
                    <textarea class="form-control" placeholder="Enter message text..." bind:value={message}></textarea>
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { messageModalOpen = false }}>Close</button>
                    <button class="btn btn-primary" on:click={sendMessage} disabled={!message}>Send</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .status-pending {
        color: #ff5d1c;
        text-transform: capitalize;
    }

    .status-approved {
        color: #4caf50;
        text-transform: capitalize;
    }

    .orange {
        color: #ff5d1c;
    }

    .green {
        color: #4caf50;
    }

    .red {
        color: #f44336;
    }

    .dropdown-wrapper {
        display: flex;
        align-items: center;
        width: 230px;
    }

    .dropdown-wrapper .form-select {
        margin-left: 10px;
        text-transform: capitalize;
    }

    .modal-custom__text {
        white-space: normal !important;
    }

    .tasks-list :global(table) {
        width: auto;
    }

    .tasks-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 10px;
        line-height: normal;
    }

    .user-image {
        max-width: 500px;
        max-height: 500px;
    }

    .analytics {
        display: inline-block;
        vertical-align: top;
        font-size: 16px;
    }

    .analytics div {
        display: inline-block;
        margin-left: 15px;
        padding-top: 10px;
    }

    .tg-icon {
        width: 20px;
        height: 20px;
        color: #2fabea;
        display: inline-block;
        font-size: 20px;
        margin-left: 2px;
    }

    .suspicious td {
        background: #ffcba0;
    }

    .blackList td {
        background: #ffafa9;
    }

    @media (max-width: 767px) {
        .tasks-list td :global(.btn.btn-primary) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 5px;
        }

        .tasks-list td :global(.btn-success) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 5px;
        }

        .tasks-list td :global(.btn-danger) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
        }
    }
</style>
